import { Helmet } from 'react-helmet-async';


export default function Seo({ 
  url = "https://abonnement-iptvfr.fr",
  image = "https://abonnement-iptvfr.fr/og-image.jpg",
  schemaMarkup = {}
}) {
  return (
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

     

      {/* Schema Markup */}
      {Object.keys(schemaMarkup).length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      )}
    </Helmet>
  );
}